import axios from 'axios';
import envService from '@/services/env.service';

const BASE_URL = envService.getApiBaseUrl() + '/sms/statistics';

export default {

    getStatistics(webId, months, email) {
        return axios.get(BASE_URL + '/' + webId + "/months/" + months, {
            headers: {
                'X-User-Email': email,
            },
        })
    },

    getStatisticsByMonthsNew(webId, months, email) {
        return axios.get(BASE_URL + '/' + webId + "/bymonths/" + months, {
            headers: {
                'X-User-Email': email,
            },
        })
    },

    getStatisticsByDaysNew(webId, days, email) {
        return axios.get(BASE_URL + '/' + webId + "/bydays/" + days, {
            headers: {
                'X-User-Email': email,
            },
        })
    },

    getStatisticsByHoursNew(webId, hours, email) {
        return axios.get(BASE_URL + '/' + webId + "/byhours/" + hours, {
            headers: {
                'X-User-Email': email,
            },
        })
    },
}